import type { ReactNode } from 'react'

export interface SectionProps {
  children?: ReactNode
}
export const Section: React.FC<SectionProps> = ({ children }) => {
  return (
    <div className="w-full border-b border-neutral-subtle pb-6 last:border-0 last:pb-0">
      {children}
    </div>
  )
}
